export default "__VITE_ASSET__CvrsARj4__"